import {NgModule} from "@angular/core";

import {AzoraCheckboxModule} from "./checkbox/checkbox";
import {AzoraInputModule} from "./input/input.module";
import {AzoraControlGroupModule} from "./control-group/control-group";
import {AzoraRadioModule} from "./radio/radio";
import {AzoraSelectModule} from "./select/select.module";
import {AzoraSwitchModule} from "./switch/switch";
import {AzoraSliderModule} from "./slider/slider.module";

const MODULES = [
    AzoraCheckboxModule,
    AzoraInputModule,
    AzoraControlGroupModule,
    AzoraRadioModule,
    AzoraSelectModule,
    AzoraSliderModule,
    AzoraSwitchModule
]

@NgModule({
    imports: MODULES,
    exports: MODULES
})
export class FormComponentsModule {
}
